import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { EPaymentMode } from "../StudentPaymentPane";
import { Table, TableColumnsType } from "antd";
import { IStudentPayment } from "../../../../models/payments.model";
import useUtil from "../../../../hooks/useUtil";
import { getDateFormat } from "../../../../lib/util";
import config from "../../../../lib/config";
import Pagination from "../../../common/Pagination";
import PaymentButtons from "./PaymentButtons";
import PaymentPaneHeader from "./PaymentPaneHeader";

interface IProps {
  data: IStudentPayment[];
  paymentMode: EPaymentMode;
  onSetPaymentMode: (mode: EPaymentMode) => void;
  setAddPaymentVisible: (visible: boolean) => void;
  setDownloadCertificateVisible: (visible: boolean) => void;
};

const PaymentToBeMade: FC<IProps> = ({
  data,
  paymentMode,
  onSetPaymentMode,
  setAddPaymentVisible,
  setDownloadCertificateVisible,
}) => {
  const { t } = useTranslation();
  const { getCommonCodeLabel } = useUtil();
  
  const [page, setPage] = useState(1);

  const columns: TableColumnsType<IStudentPayment> = [
    {
      title: t('student.student.column22'),
      dataIndex: 'semesterName',
    },
    {
      title: t('student.student.column48'),
      dataIndex: 'monthNameCode',
      render: value => getCommonCodeLabel('SY0009', value?.trim()),
    },
    {
      title: t('common.menu.class'),
      dataIndex: 'className',
    },
    {
      title: t('student.student.column45'),
      dataIndex: 'paymentTargetName',
    },
    {
      title: t('student.student.column46'),
      dataIndex: 'price',
      render: (value: number) => value.toLocaleString(),
    },
    {
      title: t('student.student.column50'),
      dataIndex: 'paymentAmount',
      render: (value: number) => value.toLocaleString(),
    },
    {
      title: t('student.student.column51'),
      dataIndex: 'discountAmount',
      width: '12%',
    },
    {
      title: t('student.student.column76'),
      render: (value: IStudentPayment) =>
        (
          value.price -
          value.paymentAmount -
          value.discountAmount
        ).toLocaleString(),
    },
    {
      title: t('student.student.column4'),
      dataIndex: 'paymentSttName',
    },
    {
      title: t('student.student.column52'),
      dataIndex: 'paymentCloseDate',
      render: (value: string) => getDateFormat(value),
    },
  ];

  return (
    <>
      <PaymentPaneHeader
        paymentMode={paymentMode}
        onSetPaymentMode={onSetPaymentMode}
        setAddPaymentVisible={setAddPaymentVisible}
        setDownloadCertificateVisible={setDownloadCertificateVisible}
      />

      <Table
        className='comm-table__area'
        columns={columns}
        dataSource={data}
        pagination={{
          current: page,
          pageSize: config.pageSize,
        }}
      />
      <div className="comm-bx__between">
        <div />
        <div className="common-paging center">
          <Pagination
            page={page}
            setPage={setPage}
            total={data.length}
          />
        </div>
        <div className="comm-btn__area right">
          <PaymentButtons
            setAddPaymentVisible={setAddPaymentVisible}
            onSetPaymentMode={onSetPaymentMode}
          />
        </div>
      </div>
    </>
  );
};

export default PaymentToBeMade;